export enum StatutEvenement {
	EN_ATTENTE = 'EN_ATTENTE',
	VALIDE = 'VALIDE',
	REFUSE = 'REFUSE',
}
